var _defs, _use, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgDelete = function SvgDelete(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 24,
    height: 24,
    viewBox: "0 0 18 18"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "delete_svg__a",
    d: "M0 0h18v18H0z"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "delete_svg__b",
    maskContentUnits: "userSpaceOnUse",
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h18v18H0z"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#fff",
    xlinkHref: "#delete_svg__a"
  })))), _use || (_use = /*#__PURE__*/React.createElement("use", {
    fill: "none",
    xlinkHref: "#delete_svg__a"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#delete_svg__b)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M10.75 4.556h1.75v1.11h-7v-1.11h1.75L7.75 4h2.5l.5.556zM7 14c-.55 0-1-.5-1-1.111V6.222h6v6.667C12 13.5 11.55 14 11 14H7z"
  }))));
};
export { SvgDelete as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHhtbG5zOnhsaW5rPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5L3hsaW5rIiB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAxOCAxOCI+CiAgPGRlZnM+CiAgICA8cmVjdCBpZD0icmVjdC0xIiB3aWR0aD0iMTgiIGhlaWdodD0iMTgiIHg9IjAiIHk9IjAiLz4KICAgIDxtYXNrIGlkPSJtYXNrLTIiIG1hc2tDb250ZW50VW5pdHM9InVzZXJTcGFjZU9uVXNlIiBtYXNrVW5pdHM9InVzZXJTcGFjZU9uVXNlIj4KICAgICAgPHJlY3Qgd2lkdGg9IjE4IiBoZWlnaHQ9IjE4IiB4PSIwIiB5PSIwIiBmaWxsPSJibGFjayIvPgogICAgICA8dXNlIGZpbGw9IndoaXRlIiB4bGluazpocmVmPSIjcmVjdC0xIi8+CiAgICA8L21hc2s+CiAgPC9kZWZzPgogIDxnPgogICAgPHVzZSBmaWxsPSJub25lIiB4bGluazpocmVmPSIjcmVjdC0xIi8+CiAgICA8ZyBtYXNrPSJ1cmwoI21hc2stMikiPgogICAgICA8cGF0aCBmaWxsLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik0xMC43NTAwMTUyNiA0LjU1NTU1Njc3aDEuNzUwMDA0Nzd2MS4xMTExMTMwOEg1LjVWNC41NTU1NTY3N2gxLjc1MDAwNDc3TDcuNzUwMDA2NjcgNGgyLjUwMDAwNjY4bC41MDAwMDE5LjU1NTU1Njc3em0tMy43NTAwMTA5NyA5LjQ0NDQ2MzI2Yy0uNTUwMDAxNjIgMC0xLjAwMDAwMjg2LS41MDAwMDA5Ni0xLjAwMDAwMjg2LTEuMTExMTEzNTVWNi4yMjIyMjY2Mmg2LjAwMDAxNzY0djYuNjY2Njc5ODZjMCAuNjExMTEyNi0uNDUwMDAxNzEgMS4xMTExMTM1NS0xLjAwMDAwMzgxIDEuMTExMTEzNTVINy4wMDAwMDQyOXoiLz4KICAgIDwvZz4KICA8L2c+Cjwvc3ZnPgo=";